import classNames from 'classnames';

import { Button } from './button';
import { ButtonProps } from './button.type';
import { BUTTON_VARIANT_M } from './config';

export const ButtonAccentPrimary = ({
  disabled,
  variant = BUTTON_VARIANT_M,
  children,
  className,
  ...props
}: ButtonProps) => {
  return (
    <Button
      disabled={disabled}
      {...props}
      variant={variant}
      className={classNames(className, {
        'text-white fill-accent-primary focus:fill-accent-primary-active': !disabled,
        'fill-accent-primary-disabled text-disabled': disabled,
      })}>
      {children}
    </Button>
  );
};
